import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PublicHeader from "@/components/layout/PublicHeader";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePageSEO } from "@/hooks/use-seo";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  usePageSEO(
    "Privacy Policy - Zoocertica",
    "Zoocertica Privacy Policy explaining how we collect, use, and protect your data on our wildlife management platform.",
    "/privacy"
  );

  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <Card>
          <CardHeader>
            <CardTitle className="text-3xl">Zoocertica Privacy Policy</CardTitle>
            <p className="text-sm text-muted-foreground">
              Updated October 2025
            </p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none dark:prose-invert space-y-6">
            <p>
              Zoocertica ("we," "our," "us") respects your privacy and is committed to protecting your data.
            </p>

            <section>
              <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>
              <p>We collect:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Account details</li>
                <li>Facility/animal data</li>
                <li>Payment info via Stripe</li>
                <li>Log data and analytics</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. How We Use Information</h2>
              <p>We use your information to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Operate the platform</li>
                <li>Manage billing</li>
                <li>Provide support</li>
                <li>Enforce limits</li>
                <li>Comply with law</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Sharing & Security</h2>
              <p>
                No data is sold. Shared only with trusted providers under confidentiality. Data encrypted and backed up daily.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Retention & Rights</h2>
              <p>
                Data retained while accounts are active. Users may request deletion. GDPR/CCPA rights honored.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Contact</h2>
              <div className="not-prose my-4 p-4 bg-muted rounded-lg">
                <p className="text-sm mb-1">
                  📧{" "}
                  <a href="mailto:support@zoocertica.com" className="text-primary hover:underline">
                    support@zoocertica.com
                  </a>
                </p>
                <p className="text-sm">
                  🌐{" "}
                  <a href="https://zoocertica.com" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
                    https://zoocertica.com
                  </a>
                </p>
              </div>
            </section>

            <div className="mt-8 p-4 bg-muted rounded-lg border">
              <p className="text-sm font-semibold text-center">
                BY USING THIS SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD THIS PRIVACY POLICY.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
